export const en = {
  title: 'Intact Forest Landscapes',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Function',
      value:
        'Identifies the world’s last remaining unfragmented forest landscapes, large enough to retain all native biodiversity and showing no signs of human alteration as of the year 2020. This layer also shows the reduction in the extent of Intact Forest Landscapes from 2000 to 2020.',
    },
    {
      label: 'Resolution',
      value: 'Approximately 1:1,000,000',
    },
    {
      label: 'Geographic coverage',
      value: 'Global',
    },
    {
      label: 'Source',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: 'Date of content',
      value: 2020,
    },
    {
      label: 'Cautions',
      value:
        'The world IFL map was created through visual interpretation of Landsat images by experts. The map may contain inaccuracies due to limitations in the spatial resolution of the imagery and lack of ancillary information about local land-use practices in some regions. In addition, the methodology assumes that fires in proximity to roads or other infrastructure may have been caused by humans, and therefore constitute a form of anthropogenic disturbance. This assumption could result in an underestimation of IFL extent in the boreal biome.',
    },
    {
      label: 'License',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Overview',
    value:
      'The Intact Forest Landscapes (IFL) data set identifies unbroken expanses of natural ecosystems within the zone of forest extent that show no signs of significant human activity and are large enough that all native biodiversity, including viable populations of wide-ranging species, could be maintained. To map IFL areas, a set of criteria was developed and designed to be globally applicable and easily replicable, the latter to allow for repeated assessments over time as well as verification. IFL areas were defined as unfragmented landscapes, at least 50,000 hectares in size, and with a minimum width of 10 kilometers. These were then mapped from Landsat satellite imagery for the year 2000.',
  },
  citation: {
    label: 'Citation',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
